/**
 * Product detail enhancements.
 *
 * Collapses a long product description to four lines behind a Read more
 * toggle, so the size options and the buy button stay above the fold on
 * products with a lot of copy. The markup is built here rather than in Liquid
 * because the description is an editor-placed text block: with JS unavailable
 * the copy simply renders in full, which is the correct fallback.
 */
(() => {
  const CLAMP_SELECTOR = '.product-details .rte';

  /** @param {HTMLElement} rte */
  function collapse(rte) {
    if (rte.closest('.accordion') || rte.dataset.otbReadmore === 'true') return;
    if (!rte.textContent.trim()) return;

    rte.dataset.otbReadmore = 'true';

    const wrapper = document.createElement('div');
    wrapper.className = 'otb-readmore';
    wrapper.dataset.open = 'false';

    const body = document.createElement('div');
    body.className = 'otb-readmore__body';
    while (rte.firstChild) body.appendChild(rte.firstChild);

    wrapper.appendChild(body);
    rte.appendChild(wrapper);

    // Only offer the toggle when the copy actually overflows the clamp.
    if (body.scrollHeight - body.clientHeight < 4) return;

    const toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'otb-readmore__toggle';
    toggle.textContent = 'Read more';
    toggle.setAttribute('aria-expanded', 'false');

    toggle.addEventListener('click', () => {
      const open = wrapper.dataset.open === 'true';
      wrapper.dataset.open = open ? 'false' : 'true';
      toggle.textContent = open ? 'Read more' : 'Read less';
      toggle.setAttribute('aria-expanded', open ? 'false' : 'true');
    });

    wrapper.appendChild(toggle);
  }

  function init() {
    document.querySelectorAll(CLAMP_SELECTOR).forEach(collapse);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Horizon re-renders the details column on variant change.
  document.addEventListener('shopify:section:load', init);
})();
